module.exports = __webpack_public_path__ + "img/2x.71729e5.jpg";